<template>
  <div>
    <!-- <van-nav-bar title="座位预约" /> -->
    <library v-if="showPage == 'library'" @notice="NextStep"></library>
    <room v-if="showPage == 'room'" :rdata="rdata" @notice="NextStep"></room>
    <seat v-if="showPage == 'seat'" :rdata="rdata" @notice="NextStep"></seat>
    <Footer page="index"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import library from "./components/library";
import room from "./components/room";
import seat from "./components/seat";
import { loadData } from '@/utils/common'

export default {
  data() {
    return {
      advList:[{}],
      noticeList:[],
      showPage:'library',
      rdata:{},
      isClean:true,
    };
  },
  created() {

  },
  components: { Footer , library , room , seat },
  methods: {
    NextStep(res){
      if(res.page == 'library'){
        this.showPage = 'room';
        this.rdata = res.rdata;
      }else if(res.page == 'room'){
        if(res.isback == '1'){
          this.showPage = 'library';
        }else{
          this.showPage = 'seat';
          this.rdata.roomId = res.roomid;
        }
      }else if(res.page == 'seat'){
        if(res.isback == '1'){
          this.showPage = 'room';
        }else{
          sessionStorage.setItem('my_targepage','seat');
          this.$router.push({ name: 'my', params: { targePage: 'seat' }})
        }
      }
    },
    gotoDetail(id){
      this.$router.push({ name: 'notice', params: { id: id }})
    }
  }
};
</script>

